// extracted by mini-css-extract-plugin
export default {"row":"Paid_row__3-ff8"};